var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},_vm._l((_vm.linkCardData),function(links,key){return _c('linkCard',{key:key,attrs:{"id":key,"title":links.title,"thumbnail":require('../assets/200/' + links.thumbnailLink),"description":links.dsc,"link":links.link,"maintnance":links.maintnance,"update":links.update,"prototype":links.prototype}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }